export enum UserStatus {
  ok = '0',
  documentExpired = '1',
  documentExpiring = '2',
  documentNotSent = '3',
  passwordExpiring = '4',
  documentRejected = '5',
}

export const mapUserStatusToAnalyticsMessage = {
  [UserStatus.ok]: '',
  [UserStatus.documentExpired]: 'documento_scaduto',
  [UserStatus.documentExpiring]: 'documento_in_scadenza',
  [UserStatus.documentNotSent]: 'documento_non_inviato',
  [UserStatus.passwordExpiring]: 'password_in_scadenza',
  [UserStatus.documentRejected]: 'documento_respinto',
};

export const getDocumentExpirationDaysEndpoint =
  'profilo-ms/ms/profile/getDocumentExpirationDays';
